const SUPPORTED_LANG_CODES = new Set(['en', 'tr']);

export function normalizeLanguage(value) {
  return String(value || '').trim().toLowerCase() === 'tr' ? 'TR' : 'EN';
}

export function languageToPathSegment(value) {
  return normalizeLanguage(value).toLowerCase();
}

export function extractLanguageFromPathname(pathname = '') {
  const firstSegment = String(pathname || '')
    .split(/[?#]/)[0]
    .split('/')
    .filter(Boolean)[0];

  if (!firstSegment) return '';
  const normalized = firstSegment.toLowerCase();
  return SUPPORTED_LANG_CODES.has(normalized) ? normalized.toUpperCase() : '';
}

function splitPathSuffix(path) {
  const value = String(path || '');
  const searchIndex = value.indexOf('?');
  const hashIndex = value.indexOf('#');

  let suffixStart = value.length;
  if (searchIndex >= 0) suffixStart = Math.min(suffixStart, searchIndex);
  if (hashIndex >= 0) suffixStart = Math.min(suffixStart, hashIndex);

  return {
    pathname: value.slice(0, suffixStart) || '/',
    suffix: value.slice(suffixStart),
  };
}

export function stripLanguagePrefix(path = '/') {
  const { pathname, suffix } = splitPathSuffix(path);
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length && SUPPORTED_LANG_CODES.has(segments[0].toLowerCase())) {
    segments.shift();
  }

  const barePath = segments.length ? `/${segments.join('/')}` : '/';
  return `${barePath}${suffix}`;
}

export function buildLocalizedPath(path = '/', lang = 'EN') {
  const value = String(path || '/');

  if (/^[a-z]+:\/\//i.test(value)) {
    return value;
  }

  const normalizedPath = value.startsWith('/') ? value : `/${value}`;
  const barePath = stripLanguagePrefix(normalizedPath);
  const prefix = `/${languageToPathSegment(lang)}`;

  if (barePath === '/') {
    return prefix;
  }

  if (barePath.startsWith('/?') || barePath.startsWith('/#')) {
    return `${prefix}${barePath.slice(1)}`;
  }

  return `${prefix}${barePath}`;
}
